import { render, staticRenderFns } from "./JoppdBDetailList.vue?vue&type=template&id=1e06b1a2&scoped=true"
import script from "./JoppdBDetailList.vue?vue&type=script&lang=js"
export * from "./JoppdBDetailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e06b1a2",
  null
  
)

export default component.exports